<template>
  <ls-table-layout>
    <template #search>
      <unsatisfactory-list-search-form @search="onSearch" ref="searchForm"/>
    </template>
    <template #btn>
      <ls-status-button>
        <a-button v-hasPermi="['unsatisfactoryReceivingList:export']" @click="onExport">导出</a-button>
        <a-button v-hasPermi="['unsatisfactoryReceivingList:autoSum']" @click="onGetSum" :loading="autoSumLoading">自动计算</a-button>
      </ls-status-button>
    </template>
    <template #table>
      <ls-api-table
        ref="dataTable"
        :columns="columns"
        :tableProps="tableProps"
        :customSelection="rowSelection"
        @change="sortFun"
        :scroll="{ x: 1200, fixScreen: true}"
        :selected-rows.sync="selectedRows"
        :toolBox="{
                density: true, // 传入String时 初始化默认表格密度
                fullScreen: false,  // 是否需要全屏
                configKey: $TableKey.UNSATISFACTORY_RECEIVING_LIST, // 表格方案配置唯一值
              }"
      >
        <template #factoryName="{text,record}">
          <span @click="JumpRoute(record)" class="cursor-pointer">{{ text }}</span>
        </template>
        <template #dataCreateTime="{text}">
          {{ $moment(text).format('YYYY-MM-DD') }}
        </template>
        <template #earlyMorningDeliveryIs="{text}">
          {{ ['晚班','早班'][text] }}
        </template>
        <template #dischargeIs="{text}">
          {{ ['否','是'][text] }}
        </template>
        <template #loadRate="{text}">
          {{ percentNum(text) }}
        </template>
        <template #beforeLoadRate="{text}">
          {{ percentNum(text) }}
        </template>
        <template #beforeTotalVolume="{text}">
          {{ formatNum(text, 2) }}
        </template>
        <template #totalVolume="{text}">
          {{ formatNum(text, 2) }}
        </template>
      </ls-api-table>
    </template>
  </ls-table-layout>
</template>
<script>
import UnsatisfactoryListSearchForm from '@/views/mes/scheduling-plan/unsatisfactory-receiving/components/unsatisfactory-list-search-form.vue'
import { COLUMNS } from '@/views/mes/scheduling-plan/unsatisfactory-receiving/enum'
import { generateLsTableResData } from '@/utils/util'
import {
  apiCalculate,
  apiExportSumReceiptPlanUnsatisfiedReport,
  apiSumReceiptPlanUnsatisfiedReport
} from '@/api/mes/scheduling-plan/unsatisfactory-receiving'
import { fixedTable } from 'lsmy-libs'

export default {
  // 不满足收货报表
  // eslint-disable-next-line
  name: 'Unsatisfactory-receiving-list', // name要和rms配置菜单路由保存一致(首字母大写)
  components: { UnsatisfactoryListSearchForm },
  mixins: [fixedTable],
  data () {
    return {
      tableProps: {
        requestApi: generateLsTableResData(apiSumReceiptPlanUnsatisfiedReport, false)
      },
      selectedRows: [],
      autoSumLoading: false
    }
  },
  computed: {
    columns() {
      return this.stickyFixedColumns(COLUMNS)
    },
    rowSelection() {
      return{
        getCheckboxProps: record => ({
          props: {
            disabled: !!record.reCalculateIs // Column configuration not to be checked
          }
        })
      }
    }
  },
  methods: {
    sortFun (p, f, { field, order }) {
      if(!order) {
        this.orderBys = []
      }else{
        this.orderBys = [
          {
            order: order,
            property: field
          }
        ]
      }
      const data = this.$refs.dataTable.searchParams
      const query = {
        data,
        orderBys: this.orderBys
      }
      delete query.searchFormLabel
      this.$refs.dataTable.searchParams = query
    },
    // 搜索
    onSearch (val = {}) {
      this.$refs.dataTable.searchParams = val
      this.$refs.dataTable.getData()
    },
    // 导出
    onExport () {
      const formData = this.$refs.searchForm.getFormData()
      apiExportSumReceiptPlanUnsatisfiedReport(formData)
    },
    // 自动计算
    onGetSum() {
      if(this.selectedRows.length <= 0) {
        this.$message.warning('请至少选择一行数据！')
        return
      }
      const list = []
      for(const item of this.selectedRows) {
        list.push(item.factoryCode)
      }
      this.autoSumLoading = true
      apiCalculate(list).then(res => {
        if(res.data.state === 100) {
          this.$message.success('计算成功')
          this.successCallBack()
        }
      }).finally(() => {
        this.autoSumLoading = false
      })
    },
    // 格式化金额
    percentNum (val) {
      if (!val) {
        return val
      }
      const value = Math.floor(Number(val) * 10000) / 100
      return value + '%'
    },
    formatNum (val, exponent) {
      if (!val) {
        return val
      }
      const result = Math.pow(10, exponent)
      let value = Math.floor(Number(val) * result) / result
      value = String(value)
      const reg = value?.indexOf(".") > -1 ? /(\d)(?=(\d{3})+\.)/g : /(\d)(?=(?:\d{3})+$)/g;
      value = value.replace(reg, '$1,')
      return value
    },
    JumpRoute(record) {
      this.$router.push({
        name: 'Unsatisfactory-receiving-detail',
        query: {
          factoryCode: record.factoryCode
        }
      })
    },
    successCallBack() {
      const params = this.$refs.searchForm.getFormData()
      this.search(params)
    }
  },
  activated() {
    this.onSearch({
      requireDeliveryTimeStart: this.$moment().startOf('day').add('1', 'days').format('YYYY-MM-DD 00:00:00'),
      requireDeliveryTimeEnd: this.$moment().endOf('day').add('1', 'days').format('YYYY-MM-DD 23:59:59')
    })
  }
}
</script>
<style lang="less" scoped>
::v-deep .ant-table-thead > tr > th, ::v-deep .ant-table-tbody > tr > td {
  padding: 4px;
}
.cursor-pointer{
  color: #007EF9;
  cursor: pointer;
}
</style>
